import { connect } from "react-redux";
import ClassificationList from "../Components/ClassificationList.jsx";
import {
  changeListOffsetAction,
  onClassificationClickAction,
} from "../classificationListActions.js";
import { isMobile } from "../../utils/common.js";

let isFirstTime = true;

const mapStateToProps = (state) => {
  const offsetAdd = isMobile() ? 2 : 5;

  let classifications, countFalseStages, falseStagesOffset, trueStagesOffset;
  if (state.teamDetails.stages !== false){
    if (isFirstTime) {


    // Filter stages by gameStatus = true and extract the first offsetAdd items
    const filteredStages = state.teamDetails.stages.filter(stage => stage.gameStatus);
    const filteredFalseStages = state.teamDetails.stages.filter(stage => !stage.gameStatus);

    if (!isMobile()) {
      if(filteredFalseStages.length){
        countFalseStages = filteredFalseStages.length;
        if (countFalseStages == 1){
          falseStagesOffset = 1;
          trueStagesOffset = 4;
        }else{
          falseStagesOffset = 2;
          trueStagesOffset = 3;
        }
      }
      else{
        falseStagesOffset = 0;
        trueStagesOffset = 5;
      }

      // Apply gameStatus True in the middle if there are coming soon game statuses (false exists)
      const reversedFalseStages = [...filteredFalseStages].reverse().slice(0, falseStagesOffset);
      const reversedClassifications = reversedFalseStages.reverse().concat(filteredStages.slice(0, trueStagesOffset));
      classifications = reversedClassifications;
    } else {
      classifications = filteredStages.slice(0, offsetAdd);
    }

    isFirstTime = false; // Update the flag to indicate that the updated logic has been executed

    } else {
      classifications =
        state.teamDetails.stages &&
        state.teamDetails.stages.slice(
          state.teamDetails.stagesOffset,
          state.teamDetails.stagesOffset + offsetAdd
        );
    }
  }
  return {
    classifications,
    activeStage: state.teamDetails.activeStage,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    onChange: (change) => dispatch(changeListOffsetAction(change)),
    onClick: (classification) =>
      dispatch(onClassificationClickAction(classification)),
  };
};

const ClassificationListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassificationList);

export default ClassificationListContainer;
